import React from "react";
import img1 from "assets/landing/block-about-cards-1.webp";
import img2 from "assets/landing/block-about-cards-2.webp";
import { useTranslation } from "locales";
import "./style.scss";

export default function BlockAboutCards() {
  const { t } = useTranslation();

  return (
    <div className="block-about-cards">
      <div className="block-about-cards__wrapper d-flex gap-6">
        <div className="block-about-cards__item box-shadow">
          <div className="block-about-cards__item-img" style={{ backgroundImage: `url(${img1})` }}></div>
          <div className="pa-6 d-flex __column">
            <div className="caption-1 fw-bold mb-3">{t("Our mission")}</div>
            <div className="text-neutral-darken-1">
              {t(
                "Our mission is to be the bridge beyond advanced study and into careers. We equip ambitious financial services talent with insider coaching, structured preparation, and clear, outcome-driven steps that turn potential into offers. In doing so, we deliver measurable impact for both individuals and the institutions that support them."
              )}
            </div>
          </div>
        </div>

        <div className="block-about-cards__item box-shadow">
          <div className="block-about-cards__item-img" style={{ backgroundImage: `url(${img2})` }}></div>
          <div className="pa-6 d-flex __column">
            <div className="caption-1 fw-bold mb-3">{t("Our vision")}</div>
            <div className="text-neutral-darken-1">
              {t(
                "To redefine how ambitious talent secures and succeeds in the world’s most competitive financial services careers.  By levelling the playing field and creating access based on ability, not connections."
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
